import { Autocomplete, TextField } from '@mui/material';

import { searchActiveUsers } from '@/tracker/entities/user';
import { useServerSearch } from '@/tracker/hooks/useServerSearch';
import { UserRef } from '@/tracker/types';

type Props = {
  ariaLabel: string;
  /** Подпись пункта «никто»; без неё значение очистить нельзя */
  emptyLabel?: string;
  onSave: (userId: string | null) => void;
  onClose: () => void;
};

const NONE: UserRef = { id: '', displayName: '' };

/** Выбор пользователя поиском на сервере: открывается сразу, выбор сохраняет, потеря фокуса — отмена */
const UserPicker: React.FC<Props> = ({ ariaLabel, emptyLabel, onSave, onClose }) => {
  const {
    query,
    setQuery,
    options: found,
    isLoading,
  } = useServerSearch({
    search: searchActiveUsers,
  });
  const options: UserRef[] = emptyLabel ? [NONE, ...found] : found;

  return (
    <Autocomplete
      size="small"
      openOnFocus
      options={options}
      // Фильтрует сервер
      filterOptions={(all) => all}
      loading={isLoading}
      loadingText="Поиск…"
      noOptionsText="Никого не нашлось"
      value={null}
      inputValue={query}
      onInputChange={(_, value, reason) => reason === 'input' && setQuery(value)}
      getOptionLabel={(option) => (option === NONE ? (emptyLabel ?? '') : option.displayName)}
      // Ключ по id: у разных пользователей бывают одинаковые имена
      renderOption={({ key: _, ...props }, option) => (
        <li key={option.id || 'none'} {...props}>
          {option === NONE ? <i>{emptyLabel}</i> : option.displayName}
        </li>
      )}
      onChange={(_, option) => {
        onClose();

        if (option) onSave(option.id || null);
      }}
      onBlur={onClose}
      // Esc при открытом списке Autocomplete забирает себе — отменяем правку сразу
      onClose={(_, reason) => reason === 'escape' && onClose()}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          placeholder="Найти пользователя"
          slotProps={{ htmlInput: { ...params.inputProps, 'aria-label': ariaLabel } }}
        />
      )}
    />
  );
};

export { UserPicker };
